import ToothChartDemo from './ToothChartDemo';
import FaceMapDemo from './FaceMapDemo';
import BodyAreaDemo from './BodyAreaDemo';
import AgreementDemo from './AgreementDemo';
import CourseDemo from './CourseDemo';
import ShopDemo from './ShopDemo';

/**
 * Which feature page gets which live demo. A feature absent from this map
 * simply renders no demo section — that is how the 21 pre-existing feature
 * pages stay byte-identical to what they shipped as.
 */
export const DEMOS = {
  'dental-charting': ToothChartDemo,
  'injectables': FaceMapDemo,
  'treatment-areas': BodyAreaDemo,
  'agreements': AgreementDemo,
  'courses': CourseDemo,
  'shop': ShopDemo,
};
